export default __webpack_public_path__ + "static/GalanoGrotesqueAltBold-86e4000d430a095c2e3bfed3615de2bd.otf";